import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ClarityService } from './core/services/clarity/clarity.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Sense Underwriting UI';

  private clarityService = inject(ClarityService);

  ngOnInit(): void {
    this.clarityService.init();
  }
}
